import { render } from "./FeaturesView.vue?vue&type=template&id=cd5ec08e&scoped=true"
import script from "./FeaturesView.vue?vue&type=script&lang=js"
export * from "./FeaturesView.vue?vue&type=script&lang=js"

import "./FeaturesView.vue?vue&type=style&index=0&id=cd5ec08e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cd5ec08e"

export default script